import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faUser, faQuestion, faBars, faSignOutAlt, faCog, faCartPlus, faReceipt, faTools, faPrint, faUsers, faStore, faCopy, faFileContract, faFileAlt, faExclamationTriangle, faChartLine, faChartBar, faTasks, faSyncAlt, faUserShield, faIdBadge } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { RoleEnum } from '../administration/users/user-role.enum';
import { AuthService } from '../auth/auth.service';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';
import { AppService } from '../app.service';
import { Subscription } from 'rxjs';
import { HelpService } from '../_common/services/help.service';
import { TranslationService } from '../_common/services/translation.service';
import { ConfigService } from '../_common/services/config.service';
import { PermissionEnum } from '../administration/users/user-permission.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  version = environment.version;

  faUser = faUser;
  faHelp = faQuestion;
  faMenu = faBars;
  faUserSettings = faCog;
  faUserSignOut = faSignOutAlt;
  faCartPlus = faCartPlus;
  faRefresh = faSyncAlt;

  faReports = faChartLine;
  faSales = faChartBar;
  faPrinterStatus = faPrint;
  faQueueStatus = faTasks;

  faDocuments = faCopy;
  faReceipts = faReceipt;
  faDailyReports = faFileContract;
  faNonFiscalsDocuments = faFileAlt;

  faAdministration = faTools;
  faPrinters = faPrint;
  faShops = faStore;
  faUsers = faUsers;
  faGdpr = faUserShield;
  faLegalNotice = faIdBadge;

  faReportIssue = faExclamationTriangle;

  isToggled = true;
  isHovered = false;
  isClicked = false;

  role: typeof RoleEnum = RoleEnum;
  languageList: string[];

  component: any = null;
  subscription: Subscription;
  permissionEnum = PermissionEnum;

  currentYear = new Date().getFullYear();

  constructor(
    public dialog: MatDialog,
    public translateService: TranslateService,
    public translationService: TranslationService,
    public helpService: HelpService,
    public appService: AppService,
    public authService: AuthService,
    public configService: ConfigService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.languageList = this.translationService.translationList;
  }

  onMouseEnter(event: any) {
    let target = event.relatedTarget as HTMLElement;
    if(target && target.classList && target.classList.contains('loading-shade')) {
      return;
    }
    if (!this.isToggled) {
      this.isHovered = true;
    }
  }

  onMouseLeave(event: any) {
    let target = event.relatedTarget as HTMLElement;
    if(target && target.classList && target.classList.contains('loading-shade')) {
      return;
    }
    if (!this.isToggled) {
      this.isHovered = false;
    }
  }

  onRefreshData() {
    if(this.component && this.hasLoadDataMethod()) {
      this.component.loadData();
    }    
  }

  onChangeLanguage(language: string) {
    this.translateService.use(language);
  }

  onActivate(componentRef: any){
    this.component = componentRef;
  }

  hasLoadDataMethod() {
    return this.component &&  this.component.loadData instanceof Function;
  }

  isUserAdmin(): boolean {
    return this.authService.hasRole(RoleEnum.Administrator);
  }

  openHelpDialog(): void {
    this.helpService.getHelp(this.router.url.slice(1), this.translateService.currentLang).subscribe((content: string) => {
      this.dialog.open(HelpDialogComponent, {
        data: {
          content: content
        },
        maxWidth: '90vw',
        maxHeight: '90vh',
        minWidth: '300px',
        minHeight: '100px',
        width: '50vw',
        height: '50vh',
        position: {
          bottom: '20px',
          right: '20px'
        },
        hasBackdrop: false,
        closeOnNavigation: true,
        autoFocus: false,
        panelClass: 'help-dialog'
      });
    })
  }
 
  openLegalNoticeDialog() {
    this.appService.callOpenLegalNoticeDialog();
  }

  openGdprDialog() {
    this.appService.callOpenGdprDialog();
  }

  getLogo() {
    return 'data:image/png;base64,' + this.configService.settings.logo;
  }
}
